import React from 'react';
import { Link } from 'react-router-dom';

const landingPages = [
  {
    name: "IA & Automatisation",
    path: "/ia-automatisation"
  },
  {
    name: "Applications Mobiles",
    path: "/developpement-mobile"
  },
  {
    name: "Solutions SaaS",
    path: "/developpement-saas"
  },
  {
    name: "Marketplaces",
    path: "/developpement-marketplace"
  },
  {
    name: "Maintenance & Support",
    path: "/maintenance-support"
  },
  {
    name: "Développement Web",
    path: "/developpement-web"
  },
  {
    name: "Prototype",
    path: "/prototype"
  }
];

const LandingPagesLinks = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Nos Solutions</h3>
      <ul className="space-y-2">
        {landingPages.map((page) => (
          <li key={page.path}>
            <Link
              to={page.path}
              className="text-gray-600 hover:text-orcsys-500 transition-colors"
            >
              {page.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LandingPagesLinks; 